<template>
  <div class="record">
    <div>
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="bdate">手机号:</label>
            <input
              v-model="search.phone"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for="bdate">交易开始时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.startDate"
              type="date"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">交易结束时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.endDate"
              type="date"
            ></el-date-picker>
          </div>

          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
         
        </form>
      </div>
      <template>
        <div class="show-list list-right">
          <el-table
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            
          </el-table>
          <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { fetchBalancePayRecordPage } from "@/api/url";
import Page from "../../commons/parking/commons/page.vue";
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        phone: "",
        startDate: "",
        endDate: "",
      },
      tableListData: [],
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      this.$get(fetchBalancePayRecordPage(), {
        page: curPage,
        limit: this.search.pageSize,
        phone: this.search.phone,
        startDate: this.search.startDate,
        endDate: this.search.endDate,
      }).then((data) => {
        if (data.status !== 200) return this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        this.tableListData = data.data.rows;
      });
    },
    searchList: function () {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    
    isJsonObj(obj) {
      try {
        if (
          typeof JSON.parse(obj) === "object" &&
          JSON.parse(obj) &&
          Object.keys(JSON.parse(obj)).length > 0
        ) {
          return true;
        }
      } catch (error) {}

      return false;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
  },

  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
  watch: {},
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.record .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>

 